/**
 * A stored value a select's own options do not carry.
 *
 * Returned so a caller can keep it as an option and flag it, rather than
 * filtering it out. Dropping it is the tempting move and the wrong one: the value
 * is still in form state, so a control showing "Select unit…" over a field that
 * holds `LBS` puts a blank in front of the reviewer and sends a value they never
 * agreed to on to the mutation. What is on screen has to be what will be
 * committed, even when what will be committed is wrong — that is the only way the
 * reviewer gets to fix it.
 *
 * Both review surfaces hit this for the same reason. An extractor reads whatever
 * the document says, and another source holds whatever it holds; neither is bound
 * by a picklist assembled in the client.
 *
 * `isKnown` rather than a list of options, because callers recognise values in
 * different ways — one has an option array, another a normalizing function that
 * accepts synonyms.
 */
export function unrecognizedOption(
  value: string | null | undefined,
  isKnown: (value: string) => boolean
): string | null {
  if (value == null || value === "") return null;
  return isKnown(value) ? null : value;
}
